// @ts-nocheck

import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import { DatePickerEnd } from "../../components/select-date-end";
import { DatePickerStart } from "../../components/select-date-start";
import { SelectBranch } from "../../components/select-react-branches";
import { SelectCenterCost } from "../../components/select-react-center-cost";
import axios from "axios";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Icons } from "../../components/spinner";
import useStoreTimToa from "../../store/useStoreTimToa";
import { CurrentEmployeesWorking } from "../../components/charts/tim-toa/CurrentEmployeesWorking";
import { formatDateFromSelect } from "../../utils/formatDateFromSelect";
import { formatDataChartCurrentEmployeesWorking } from "../../utils/formatDataChartCurrentEmployeesWorking";
import { formattUrlParams } from "../../utils/formattUrlParams";
import { ClockRegisterEmployees } from "../../components/charts/tim-toa/ClockRegisterEmployees";
import { formatDataChartClockRegisterEmployee } from "../../utils/formatDataChartClockRegisterEmployee";
import { WorkOccupation } from "../../components/charts/tim-toa/WorkOccupation";
import { OccupationBySupervisor } from "../../components/charts/tim-toa/OccupationBySupervisor";
import { EmployeeStatus } from "../../components/charts/tim-toa/EmployeeStatus";
import { PriorityByTime } from "../../components/charts/tim-toa/PriorityByTime";
import { OpenCloseTSK } from "../../components/charts/tim-toa/openCloseTSK";
import { ChartFleetTrackBars } from "../../components/charts/tim-toa/ChartFleetTrackBars";

export default function FleetTrack() {
  const [options, setOptions] = useState({});
  const { centerCost, branch, startDate, endDate, setLoadingChartFleet, setFleetData } =
    useStoreTimToa((state) => state);

  async function getCurrentEmployeesWorking() {
    setLoadingChartFleet(true);
    setFleetData(null);

    const url = formattUrlParams({
      centerCost,
      branch,
      startDate,
      endDate,
      tim: true,
      baseUrl: "https://radar.tlpservicos.com.br/api/tracking/get-fuel",
    });

    try {
      const { data } = await axios.get(url);
      setFleetData(data);
    } catch (error) {
      console.error(error);
    }
    setLoadingChartFleet(false);
  }

  async function handleGenerateCharts() {
    getCurrentEmployeesWorking();
  }

  return (
    <>
      <div className="flex gap-2 mb-4">
        <SelectCenterCost />
        <SelectBranch />
        <DatePickerStart />
        <DatePickerEnd />
        <Button onClick={handleGenerateCharts}>Gerar Gráficos</Button>
      </div>
      <div className="grid grid-cols-2 gap-8 px-8">
        <ChartFleetTrackBars />
      </div>
    </>
  );
}
